import { render, staticRenderFns } from "./CompPopupTable.vue?vue&type=template&id=55093ab6&"
import script from "./CompPopupTable.vue?vue&type=script&lang=js&"
export * from "./CompPopupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports